









import { Component, Prop, Vue } from 'vue-property-decorator';
import ProgressBar from '@/components/atoms/ProgressBar.vue';
import Chip from '@/components/atoms/Chip.vue';

@Component({
  components: {
    ProgressBar,
    Chip,
  },
})
export default class SkillsCompleted extends Vue {
  @Prop() completed!: number;

  @Prop() total!: number;

  get chipText(): string {
    if (this.total && this.total > 0) {
      return `${this.completed}/${this.total}`;
    }
    return 'N/A';
  }
}
